import { render } from "./BlockEnderecoEmpresarial.vue?vue&type=template&id=63a1e031"
import script from "./BlockEnderecoEmpresarial.vue?vue&type=script&lang=js"
export * from "./BlockEnderecoEmpresarial.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockEnderecoEmpresarial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63a1e031"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63a1e031', __exports__)) {
    console.log('reload')
    api.reload('63a1e031', __exports__)
  }
  
  module.hot.accept("./BlockEnderecoEmpresarial.vue?vue&type=template&id=63a1e031", () => {
    console.log('re-render')
    api.rerender('63a1e031', render)
  })

}


export default __exports__